import LogoutButton from "@/components/LogoutButton";
import Icon from "@/components/Ui/Icon";
import VendorCardList from "@/components/VendorSelect/VendorCardList";
import { show } from "@intercom/messenger-js-sdk";
import Image from "next/legacy/image";
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

const tailwindFadeIn = (isRendered: boolean) => [
  "inline-block transition-opacity delay-500 duration-750 ease-in",
  !isRendered && "opacity-0",
  isRendered && "opacity-100 translate-y-0",
];

const FullscreenVendorSelect = () => {
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => {
      setIsRendered(true);
    });
    return () => setIsRendered(false);
  }, []);

  return (
    <div className="row min-h-full w-full overflow-hidden bg-[url('https://assets.sesamy.com/images/login-bg.jpg')] bg-cover bg-center text-sm sm:bg-fixed sm:bg-top-left">
      <div className="row-up-left w-[calc(100%-theme(space.2)-theme(space.2))] max-w-[1295px] flex-nowrap! sm:w-[calc(100%-theme(space.16)-theme(space.16))] sm:pt-10">
        <div className="column-left">
          <div
            className={twMerge(
              "w-full pt-6 pb-4 text-center sm:text-left",
              tailwindFadeIn(isRendered),
            )}
          >
            <Icon className="text-2xl md:text-2xl" name="portal" />
          </div>
          <div className="bg-card relative flex min-h-[calc(100vh-148px)] w-full flex-col rounded-2xl px-5 py-10 text-white sm:min-h-[700px] sm:max-w-md sm:px-14 sm:py-14 md:min-w-md">
            <div
              className={twMerge(
                "flex flex-1 flex-col",
                tailwindFadeIn(isRendered),
              )}
            >
              <div className="mb-4 text-2xl font-medium">
                Select your vendor
              </div>
              <div className="text-muted-foreground mb-8">
                Your user has access to the following vendors. Please, choose
                the data you'd like to analyse.
              </div>
              <div className="mb-8 flex flex-1 flex-col justify-center">
                <VendorCardList />
              </div>

              <LogoutButton
                className="w-full"
                text="I want to use another account"
                variant="ghost"
              />
            </div>
          </div>
          <div className="flex w-full items-center justify-center px-6 pt-4 pb-8 sm:justify-start">
            <div
              className={twMerge(
                "flex justify-center space-x-2 text-xs text-white sm:justify-normal md:text-xs",
                tailwindFadeIn(isRendered),
              )}
            >
              <button
                onClick={() => show()}
                className="hover:text-foreground text-xs text-white md:text-xs"
              >
                Need Help?
              </button>
            </div>
          </div>
        </div>
        <div className="sm:column-up-left hidden flex-1 py-32 pl-8 portrait:hidden">
          <div className="relative text-5xl font-medium">
            <span
              className={twMerge(
                "w-[calc(100%+theme(space.2))] sm:w-[calc(100%+theme(space.16))]",
                tailwindFadeIn(isRendered),
              )}
            >
              Follow your data in real time.
            </span>
            <br />
            <span
              className={twMerge(
                "text-muted-foreground inline-block w-[calc(100%+theme(space.2))] transition-opacity delay-500 duration-750 ease-in sm:w-[calc(100%+theme(space.16))]",
                !isRendered && "opacity-0",
                isRendered && "opacity-100",
              )}
            >
              Whilst getting you more revenue.
            </span>
            <div
              className={twMerge(
                "absolute top-[calc(theme(space.14)+100%-theme(space.1))] right-0 -left-6 w-[720px] transition-[transform,opacity] delay-500 duration-750 md:top-[calc(theme(space.20)+100%-theme(space.1))] md:-left-7 md:w-[920px]",
                !isRendered && "translate-y-[50%] opacity-0",
                isRendered && "opacity-100",
              )}
              data-testid="dashboard-video"
            >
              <Image
                className="h-auto w-full"
                src="/dashboard-tablet-frame.png"
                alt="a tablet frame with graphics within it"
                priority
                width={920}
                height={698}
              />
              <div className="absolute top-[6%] right-[6.1%] left-[6.1%]">
                <div className="relative pb-[75%]">
                  <Image
                    className="absolute top-0 left-0 h-full w-full border-0"
                    src="/dashboard-splash-image.png"
                    alt="tablet graphics showing Sesamy Portal dashboard"
                    priority
                    width={808}
                    height={600}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullscreenVendorSelect;
